<div class="login-card">
  <h2 class="login-card__title">
    {{ "login.loginTitle" | transloco | uppercase }}
  </h2>

  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <!-- E-mail -->
    <div
      class="field"
      *ngIf="loginForm.controls['identification'] as identification"
    >
      <label class="field__label">{{ "login.email" | transloco }} <span class="field__req">*</span></label>
      <div
        class="field__input"
        [class.is-invalid]="identification.touched && identification.invalid"
      >
        <mat-icon fontSet="material-icons-round">mail_outline</mat-icon>
        <input
          formControlName="identification"
          placeholder="{{ 'login.emailEx' | transloco }}"
        />
      </div>
      <span
        class="field__error"
        *ngIf="identification.touched && identification.hasError('required')"
        >{{ "errors.required" | transloco }}</span
      >
      <span
        class="field__error"
        *ngIf="identification.touched && identification.hasError('email')"
        >{{ "errors.email" | transloco }}</span
      >
    </div>

    <!-- Password -->
    <div class="field" *ngIf="loginForm.controls['password'] as password">
      <label class="field__label">{{ "login.password" | transloco }} <span class="field__req">*</span></label>
      <div
        class="field__input"
        [class.is-invalid]="password.touched && password.invalid"
      >
        <mat-icon fontSet="material-icons-round">lock_outline</mat-icon>
        <input
          placeholder="{{ 'login.passwordEx' | transloco }}"
          formControlName="password"
          [type]="passwordShown() ? 'text' : 'password'"
        />
        <mat-icon
          class="field__toggle"
          (click)="passwordShown.set(true)"
          *ngIf="!passwordShown()"
          fontSet="material-icons-round"
          >visibility_off</mat-icon
        >
        <mat-icon
          class="field__toggle"
          (click)="passwordShown.set(false)"
          *ngIf="passwordShown()"
          fontSet="material-icons-round"
          >visibility</mat-icon
        >
      </div>
      <span
        class="field__error"
        *ngIf="password.touched && password.hasError('required')"
        >{{ "errors.required" | transloco }}</span
      >
    </div>

    <app-button
      class="login-card__submit"
      [fullWidth]="true"
      [disabled]="_auth.loading"
      text="{{ 'login.login' | transloco }}"
    ></app-button>
  </form>

  <div class="login-card__footer">
    <p>
      {{ "login.noAccount" | transloco }}
      <a routerLink="../register" class="accent-link">{{
        "login.signUpHere" | transloco
      }}</a>
    </p>
    <small
      >{{ "login.quickRegistrationMessageV2Part1" | transloco
      }}<span class="free-highlight">{{
        "login.quickRegistrationMessageV2Free" | transloco
      }}</span
      >{{ "login.quickRegistrationMessageV2Part2" | transloco }}</small
    >
  </div>
</div>
